import request from '@/utils/request'
//视频详情
export function getVideo(data) {
  return request({
    url: '/app/course/selectCourseInfoByCourseId',
    method: 'post',
    data
  })
}

//视频详情下拉列表数据
export function getDownList(data) {
  return request({
    url: '/app/course/selectGradeAndSubjectAndIsOpen',
    method: 'post',
    data
  })
}

//视频详情修改数据保存
export function setEdit(data) {
  return request({
    url: '/app/course/updateCourse',
    method: 'post',
    data
  })
}

//课程上下架
export function updateUserInfo(data) {
  return request({
    url: '/app/course/updateCourseIsStart',
    method: 'post',
    data
  })
}
 
//删除课程

export function deleteCourse(data) {
  return request({
    url: '/app/course/deleteCourseBycourseId',
    method: 'post',
    data
  })
}

//查询是否收藏
export function getCollection(data) {
  return request({
    url: '/app/course/selectCourseCollectByUserIdAndCourseId',
    method: 'post',
    data
  })
}

//点击收藏
export function setCollectionYes(data) {
  return request({
    url: '/app/course/collectCourseIdAndUserId',
    method: 'post',
    data
  })
}

//点击取消收藏
export function setCollectionNo(data) {
  return request({
    url: '/app/course/deleteCollectCourseIdAndUserId',
    method: 'post',
    data
  })
}